import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Grid } from 'semantic-ui-react';
import { SuccessContainer } from '../../components';

import './auth.scss';

class WelcomeToWhitebox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;

    return (
      <Grid.Row>
        <Container className="email-verification-container">
          <Grid>
            <Grid.Row>
              <SuccessContainer
                header={t('auth.hello')}
                msg={t('auth.welcome_to_takso')}
                description={[
                  <span>
                    {t('auth.your_account_has_been_activated_successfully')}
                  </span>,
                  <br />,
                  <span>{t('auth.you_can_now_sign_in_to_your_account')}</span>,
                ]}
                success={true}
                button={t('auth.sign_in')}
                buttonRoute="/signin"
              />
            </Grid.Row>
          </Grid>
        </Container>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(WelcomeToWhitebox));
